<template>
  <v-dialog :value="true" persistent scrollable transition="scroll-y-transition">
    <v-card>
      <v-card-title class="headline">Добавить место</v-card-title>

      <v-card-text>
        <p>Чтобы добавить новую точку на карту кликните на карте в необходимом месте.</p>

        <p>
          Пожалуйста, кликните на карте в наиболее точном месте и, по возможности, добавьте больше
          информации о заведении. Это поможет другим людям проще найти заведение.
        </p>
      </v-card-text>

      <v-card-actions>
        <v-btn color="blue darken-1" text @click="close">Закрыть</v-btn>

        <v-spacer />

        <v-btn color="primary" @click="confirm">Продолжить</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'Create',

  methods: {
    close() {
      this.$emit('close');
    },

    confirm() {
      this.$emit('confirm');
    },
  },
};
</script>

<style scoped></style>
